import request from '@/utils/request'

// 提交
export function submitInfo(data) {
  return request({
    url: '/mailbox-system/mail/box/save',
    method: 'post',
    data,
    isToken: true
  })
}

// 文件上传
export function handleUpload(data) {
  return request({
    url: '/mailbox-system/oss/file/upload',
    method: 'post',
    data
  })
}

// 文件下载
/* export function handleDownload(fileName) {
  return request({
    url: `/mailbox-system/oss/file/download?fileName=` + fileName,
    method: 'get',
    fileName
  })
} */
// 文件删除
export function handleDelete(id) {
  return request({
    url: `/mailbox-system/oss/file/delete?id=` + id,
    method: 'post',
    id
  })
}

// 图片-视频预览
export function SeeImg(params) {
  return request({
    url: '/mailbox-system/oss/file/preview' + params.id,
    method: 'get'
  })
}

// 图片验证码
export function getCodeImg() {
  return request({
    url: '/mailbox-system/mail/box/generateImageCode',
    method: 'get',
    responseType: 'blob'
  })
}
// 发送手机验证码
export function postSendSmsCode(data) {
  return request({
    url: `/mailbox-system/mail/box/tokens/sendSmsCode`,
    method: 'post',
    data
  })
}
// 校验手机验证码是否正确
export function checkSmsCode(data) {
  return request({
    url: `/mailbox-system/mail/box/checkSmsCode/code`,
    method: 'post',
    data
  })
}
